import { Box } from "@mui/material";
import React from "react";
import styles from "./Spinner.module.css";

type SpinnerProps = React.ComponentProps<typeof Box> & {
  color?: string;
  size?: string;
}

const Spinner: React.FC<SpinnerProps> = ({
  color = "currentColor", size = "1em", style, className, ...props
}) => {
  return (
    <Box
      {...props}
      component={"span"}
      color={color}
      style={{ ...style, "--color": color, "--size": size } as React.CSSProperties}
      className={[styles.Spinner, className].join(" ")}>
    </Box>
  );
}

export default Spinner;
